import isTouchDevice from "./helpers/isTouchDevice";

const floatingTeaser = () =>{
    if(document.querySelector('.ume-starter-floating-teaser')){
        const teaser = document.querySelector('.ume-starter-floating-teaser');
        window.addEventListener('scroll', function () {
            let minificationBreakpoint = 150;
            teaser.classList.remove('ume-starter-floating-teaser-mobile-zoom');
            let navbarCollapseBreakpoint = window.matchMedia("screen and (min-width: 1199px)");

            const matches = navbarCollapseBreakpoint.matches ? navbarCollapseBreakpoint.matches : navbarCollapseBreakpoint.msMatchesSelector;

            if (matches) {
                collapseTeaser(window.scrollY);
            }else{
                minificationBreakpoint = 50;
                collapseTeaser(window.scrollY);
            }
            function collapseTeaser(scrollY) {
                if (scrollY >= minificationBreakpoint && !teaser.classList.contains('ume-starter-floating-teaser--career-scrolled')) {
                    teaser.classList.add('ume-starter-floating-teaser--career-scrolled');

                    setTimeout(()=>{
                    teaser.classList.add('ume-starter-floating-teaser--career-scrolled__complete');
                    }, 1000)

                } else if (scrollY < minificationBreakpoint) {
                    teaser.classList.remove('ume-starter-floating-teaser--career-scrolled__complete');
                    teaser.classList.remove('ume-starter-floating-teaser--career-scrolled');

                }
            }
        });
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if(vw < 1199 || isTouchDevice()){
            document.addEventListener('click', ev =>{
                if( ev.target.closest('.ume-starter-floating-teaser-double') && ev.target.closest('.ume-starter-floating-teaser-link')) {
                    let link = ev.target.closest('.ume-starter-floating-teaser-link');
                    if(link.classList.contains('ume-starter-floating-teaser-link-zoom')) return;
                    ev.preventDefault();
                    link.classList.add('ume-starter-floating-teaser-link-zoom')
                    let otherLink = document.querySelector('.ume-starter-floating-teaser-link:not(.ume-starter-floating-teaser-link-zoom)');
                    if(otherLink !== null && otherLink !== undefined){
                        otherLink.classList.add('d-none');
                    }
                    return;
                }
                if( document.querySelector('.ume-starter-floating-teaser-link-zoom') && !ev.target.closest('.ume-starter-floating-teaser-link-zoom')) {
                    let link = document.querySelector('.ume-starter-floating-teaser-link-zoom');
                    let otherLink = document.querySelector('.ume-starter-floating-teaser-link:not(.ume-starter-floating-teaser-link-zoom)');
                    if(otherLink !== null && otherLink !== undefined){
                        otherLink.classList.remove('d-none');
                    }
                    link.classList.remove('ume-starter-floating-teaser-link-zoom')

                    return;
                }

                if(ev.target.closest('.ume-starter-floating-teaser') && !ev.target.closest('.ume-starter-floating-teaser-double')) {
                    if(ev.target.closest('.ume-starter-floating-teaser-mobile-close')){
                        teaser.classList.remove('ume-starter-floating-teaser-mobile-zoom');
                        return;
                    }
                    if(teaser.classList.contains('ume-starter-floating-teaser-mobile-zoom')) return;
                    ev.preventDefault();
                    teaser.classList.add('ume-starter-floating-teaser-mobile-zoom');
                    return;
                }else {
                    if(teaser.classList.contains('ume-starter-floating-teaser-mobile-zoom')){
                        teaser.classList.remove('ume-starter-floating-teaser-mobile-zoom');
                    }
                    return;
                }


            })
        }
        else{
            teaser.classList.remove('ume-starter-floating-teaser-mobile-zoom');
        }
    }
}
export default floatingTeaser;